export const COUNTRIES_LIST = "COUNTRIES_LIST";
export const COUNTRIES_CREATE = "COUNTRIES_CREATE";
export const COUNTRIES_UPDATE = "COUNTRIES_UPDATE";
export const COUNTRIES_DELETE = "COUNTRIES_DELETE";
export const COUNTRIES_SHOW = "COUNTRIES_SHOW";
export const COUNTRIES_PUBLIC_LIST = "COUNTRIES_PUBLIC_LIST";
